module.exports = __webpack_public_path__ + "static/receptioniste-ada06fc01b014f71e50e572491d9d42a.png";